import { generatePath } from "@routes/generatePath.ts";
import type { ID, IDeviceTypes, IPatientType } from "@constants";

const viewStoredResultRoute = "/stored-result/view/:patient_id/:patient_type";
const viewAppointmentStoredResultRoute =
  "/stored-result/appointment/:appointment_id/view/:patient_id/:patient_type";

export interface IViewStoredResultRouteParams {
  patient_id: ID;
  patient_type: IPatientType;
}

export interface IViewAppointmentStoredResultRouteParams {
  patient_id: ID;
  patient_type: IPatientType;
  appointment_id: ID;
}

export interface ISelfReportParams {
  selectedFamilyMemberName?: string;
  selectedFamilyMemberId?: string;
  selectedDeviceId?: IDeviceTypes;
  selectedDeviceValue?: string;
}

export const path = {
  view: {
    route: viewStoredResultRoute,
    link: (params: IViewStoredResultRouteParams) =>
      generatePath(viewStoredResultRoute, params),
  },
  viewAppointment: {
    route: viewAppointmentStoredResultRoute,
    link: (params: IViewAppointmentStoredResultRouteParams) =>
      generatePath(viewAppointmentStoredResultRoute, params),
  },
  patientList: {
    route: "/family-member-results",
    link: () => path.patientList.route,
  },
  selfReport: {
    route: "/self-report",
    link: (params?: ISelfReportParams) => {
      const urlParams = new URLSearchParams({ ...params });

      return params
        ? generatePath(path.selfReport.route, undefined, urlParams)
        : path.selfReport.route;
    },
  },
};
